import { convertMBToMiB } from '@/utils/conversions';

type VideoDropzoneOptions = {
    url: string;
    method: 'put';
    headers: {
        'Content-Type': 'video/mp4';
    };
    maxFiles: 1;
    addRemoveLinks: true;
    parallelUploads: 1;
    acceptedFiles: 'video/mp4';
    autoQueue: true;
    autoProcessQueue: false;
    maxFilesize: number;
};

export default function getVideoDropzoneOptions(): VideoDropzoneOptions {
    const emptyUrlToAvoidDropzoneError = 'about:blank';
    return {
        url: emptyUrlToAvoidDropzoneError,
        method: 'put',
        headers: {
            'Content-Type': 'video/mp4',
        },
        maxFiles: 1,
        addRemoveLinks: true,
        parallelUploads: 1,
        acceptedFiles: 'video/mp4',
        autoQueue: true,
        autoProcessQueue: false,
        maxFilesize: convertMBToMiB(30),
    };
}
